import { render, staticRenderFns } from "./compra.vue?vue&type=template&id=b18035aa"
import script from "./compra.vue?vue&type=script&lang=js"
export * from "./compra.vue?vue&type=script&lang=js"
import style0 from "./compra.vue?vue&type=style&index=0&id=b18035aa&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports